import React from "react";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExportMenu from "../../../Common/ExportMenu/ExportMenu";

const ExportDepartment = ({ departmentTableData }) => {

    // Export to Excel
    const exportToExcel = async () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const cumulativeHeadingReport = `Department Details`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Departments");

        const boldFont = { bold: true };
        const downloadDateTime = `Department Report Generated on: ${formattedDate} ${formattedTime}`;
        const dateTimeRow = worksheet.addRow(["", downloadDateTime, "", "", ""]);
        worksheet.mergeCells(1, 2, 1, 4);
        dateTimeRow.getCell(2).font = boldFont;
        dateTimeRow.getCell(2).alignment = { horizontal: "center" };

        const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
        worksheet.mergeCells(2, 3, 2, 5);
        cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 3 && colNumber <= 5) {
                cell.font = boldFont;
                cell.alignment = { horizontal: "center" };
            }
        });

        worksheet.addRow([""]);

        const tableHeaderRow = worksheet.addRow([
            "S.No", "Department Name", "Status" , "Last Modified By"
        ]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.alignment = { horizontal: "left" };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "003366" }
            };
        });

        departmentTableData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                // item.departmentId || "N/A",
                item.departmentName || "N/A",
                item.isActive ? "Active" : "InActive",
                item.createdByName ? item.createdByName : "N/A"
            ]);
        });

        worksheet.columns = [{ width: 5 }, { width: 20 }, { width: 20 }, { width: 20 }];
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "DepartmentDetailsReport.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Department Report Generated on: ${formattedDate} ${formattedTime}`;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Department Details", 14, 20);
        doc.setFontSize(12);
        doc.text(downloadDateTime, 14, 30);

        const tableColumn = ["S.No", "Department", "Status", "Last Modified By"];
        const tableRows = departmentTableData.map((row, index) => [
            index + 1,
            row.departmentName || "N/A",
            row.isActive ? "Active" : "InActive",
            row.createdByName ? row.createdByName : "N/A"

        ]);

        const tableOptions = {
            startY: 40,
            head: [tableColumn],
            body: tableRows,
            theme: "grid",
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: "linebreak",
                valign: "middle",
            },
            headStyles: {
                fillColor: [0, 51, 102],
                textColor: [255, 255, 255],
                fontStyle: "bold",
            },
            bodyStyles: {
                fontSize: 8,
                halign: "left",
            },
        };
        autoTable(doc, tableOptions);
        doc.save("departments.pdf");
    };

    return (
        <ExportMenu
            items={[
                { label: "Excel", icon: "fa-solid fa-file-excel", onClick: exportToExcel },
                { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: exportToPDF },
            ]}
        />
    );
};

export default ExportDepartment;
